import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSizeGuideThunk } from "../redux/sizeGuideSlice";

export default function useSizeGuide() {
    const dispatch = useDispatch();

    const { data, status } = useSelector(
        (state) => state.sizeGuide
    );

    const loading = status === "loading";

    // Carpet
    const [activeShape, setActiveShape] = useState(null);
    const [shapeData, setShapeData] = useState(null);
    const [tabLoading, setTabLoading] = useState(false);

    // Room
    const [activeRoom, setActiveRoom] = useState(null);
    const [roomData, setRoomData] = useState(null);
    const [roomTabLoading, setRoomTabLoading] = useState(false);

    // Fetch only once
    useEffect(() => {
        if (!data && status === "idle") {
            dispatch(fetchSizeGuideThunk());
        }
    }, [dispatch, data, status]);

    // Initialize default tabs
    useEffect(() => {
        if (!data) return;

        const firstShape =
            data?.content?.[0]?.size_guides?.[0];
        const firstRoom =
            data?.content?.[1]?.size_guides?.[0];

        if (firstShape) {
            setActiveShape(firstShape.id);
            setShapeData(firstShape);
        }

        if (firstRoom) {
            setActiveRoom(firstRoom.id);
            setRoomData(firstRoom);
        }
    }, [data]);

    const selectShape = (id) => {
        if (!data || id === activeShape) return;

        setTabLoading(true);
        setActiveShape(id);

        setTimeout(() => {
            const guide =
                data.content[0].size_guides.find(
                    (g) => g.id === id
                );
            setShapeData(guide);
            setTabLoading(false);
        }, 250);
    };

    const selectRoom = (id) => {
        if (!data || id === activeRoom) return;

        setRoomTabLoading(true);
        setActiveRoom(id);

        setTimeout(() => {
            const room =
                data.content[1].size_guides.find(
                    (r) => r.id === id
                );
            setRoomData(room);
            setRoomTabLoading(false);
        }, 250);
    };

    return {
        data,
        loading,

        // Carpet
        activeShape,
        shapeData,
        selectShape,
        tabLoading,

        // Room
        activeRoom,
        roomData,
        selectRoom,
        roomTabLoading,
    };
}
